/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */


/*@ngInject*/
export default function ConverterTableConfig($q, $translate, $mdDialog, $document, $state, toast, types, utils, tkDialogs, userService,
                                           converterService) {

    var service = {
        getConfig: getConfig
    }

    return service;

    function getConfig(params) {
        var deferred = $q.defer();
        var currentUser = userService.getCurrentUser();
        var authority = currentUser.authority;
        var scope = types.authority[authority].scope;
        var access = types.authority[authority].access;
        var tableConfiguration = createConverterConfig(scope, access, params);
        deferred.resolve(tableConfiguration);
        return deferred.promise;
    }

    function createConverterConfig(scope, access, params, entityTitle) {

        var tableConfiguration = {

            scope: scope,

            entityType: types.entityType.converter,

            tableTitle: getTitle(scope, entityTitle),

            columns: [
                { key: 'createdTime',
                    title: 'entity.createdTime'},
                { key: 'name',
                    title: 'converter.name'},
                { key: 'type',
                  title: 'converter.type',
                  cellContentFunction: (value) => $translate.instant(types.converterType[value].name)
                }
            ],

            loadEntities: () => {return converterService.getCustomerConverters()},
            loadEntity: (entityId) => {return converterService.getConverter(entityId)},
            saveEntity: (entity) => {return converterService.saveConverter(entity)},
            deleteEntity: (entityId) => {return converterService.deleteConverter(entityId)},

            addEnabled: () => {
                return access == types.access.admin;
            },
            detailsReadOnly: () => {
                return access == types.access.user;
            },
            deleteEnabled: () => {
                return access == types.access.admin;
            },
            entitiesDeleteEnabled: () => {
                return access == types.access.admin;
            },
            deleteEntityTitle: (entity) => {
                return $translate.instant('converter.delete-converter-title', {name: entity.name});
            },
            deleteEntityContent: (/*entity*/) => {
                return $translate.instant('converter.delete-converter-text');
            },
            deleteEntitiesTitle: (count) => {
                return $translate.instant('converter.delete-converters-title', {count: count}, 'messageformat');
            },
            deleteEntitiesContent: (/*count*/) => {
                return $translate.instant('converter.delete-converters-text');
            }

        };

        tableConfiguration.actionCellDescriptors = [
        ];

        utils.tableConfigDefaults(tableConfiguration);

        return tableConfiguration;
    }

    function getTitle(scope, entityTitle) {
        var title = $translate.instant('converter.converters');

        if (entityTitle && entityTitle.length) {
            title = entityTitle + ': ' + title;
        }
        return title;
    }

}



// WEBPACK FOOTER //
// ./src/app/converter/converter-table.config.js